import defaultAttributes from '../defaultAttributes';

const Check = [
  'svg',
  defaultAttributes,
  [['polyline', { points: '20 6 9 17 4 12' }]],
];

export default Check;
